import React, { useEffect, useState } from "react";
import styles from "./Event.module.css";
import { Trash2 } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Button,
} from "@mui/material";

const ManageEvent = () => {
  const [events, setEvents] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(5);

  const handleNavigate = (path) => {
    window.location.href = path;
  };

  const navigateToViewEvent = (eventId) => {
    handleNavigate(`view-event/${eventId}`);
  };

  const handleButtonClick = (action) => {
    if (action === "Add Event") {
      handleNavigate("add-event");
    } else {
      alert(`${action} button clicked!`);
    }
  };

  const handleDeleteEvent = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this event?"
    );

    if (confirmDelete) {
      try {
        const response = await fetch(
          `https://cms-test.my-ogawa.com/backend/script/bodyfriend/event/delete_event.php?id=${id}`,
          {
            method: "DELETE",
          }
        );

        if (response.ok) {
          alert("Event deleted successfully");
          fetchEvents(currentPage, limit);
        } else {
          alert("Error deleting event");
        }
      } catch (error) {
        console.error("Error deleting event:", error);
      }
    }
  };

  const fetchEvents = async (page, limit) => {
    try {
      const response = await fetch(
        `https://cms-test.my-ogawa.com/backend/script/bodyfriend/event/getAllEvents.php?page=${page}&limit=${limit}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();

      setEvents(data.events);
      setTotalPages(Math.ceil(data.total / limit));
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  useEffect(() => {
    fetchEvents(currentPage, limit);
  }, [currentPage, limit]);

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage + 1);
  };

  const handleRowsPerPageChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  return (
    <div>
      <h1>Manage Events</h1>

      <div className={styles.wrapButton}>
        <Button
          variant="contained"
          color="success"
          onClick={() => handleButtonClick("Add Event")}
        >
          Add Event
        </Button>
      </div>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="event table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Event ID</TableCell>
              <TableCell align="center">Event Name</TableCell>
              <TableCell align="center">Start Date</TableCell>
              <TableCell align="center">End Date</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((event) => (
              <TableRow
                key={event.id}
                hover
                onClick={() => navigateToViewEvent(event.id)}
                style={{ cursor: "pointer" }}
              >
                <TableCell align="center">{event.id}</TableCell>
                <TableCell align="center">{event.name}</TableCell>
                <TableCell align="center">{event.start_date}</TableCell>
                <TableCell align="center">{event.end_date}</TableCell>
                <TableCell align="center">
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => handleDeleteEvent(event.id)}
                  >
                    <Trash2 size={20} />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50]}
        component="div"
        count={totalPages * limit}
        rowsPerPage={limit}
        page={currentPage - 1}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </div>
  );
};

export default ManageEvent;
